import { computed } from 'vue'

export const useBreakpoint = () => {
  const { $viewport } = useNuxtApp()

  const isBrowser = computed((): boolean => {
    return import.meta.client
  })

  const isDesktop = computed((): boolean => {
    return $viewport?.isGreaterOrEquals('vp1440') ?? false
  })

  const isTablet = computed((): boolean => {
    return ($viewport?.isLessThan('vp1440') && $viewport?.isGreaterOrEquals('vp1280')) ?? false
  })

  const isTabletSmall = computed((): boolean => {
    return ($viewport?.isLessThan('vp1280') && $viewport?.isGreaterOrEquals('vp768')) ?? false
  })

  const isMobile = computed((): boolean => {
    return $viewport?.isLessThan('vp768') ?? false
  })

  const isLessThan1280 = computed((): boolean => {
    return $viewport?.isLessThan('vp1280') ?? false
  })

  const isLessThan1024 = computed((): boolean => {
    return $viewport?.isLessThan('vp1024') ?? false
  })

  const currentDevice = computed((): 'mobile' | 'tablet' | 'desktop' => {
    if (isMobile.value) return 'mobile'
    if (isTablet.value) return 'tablet'
    return 'desktop'
  })

  return {
    isMobile,
    isTablet,
    isTabletSmall,
    isDesktop,
    isLessThan1280,
    isLessThan1024,
    currentDevice,
    isBrowser,
  }
}
